<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
      <div style="padding-bottom: 30px;" v-loading="loading">
        <el-table
          v-if="seznamDrzav !== null"
          :data="seznamDrzav">
            <el-table-column
              prop="drzava"
              label="Država">
            </el-table-column>
          <el-table-column
            prop="drzavaIso"
            label="Oznaka države">
          </el-table-column>
          <el-table-column
            prop="operater"
            label="Operater">
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>

<script>
import ClientAgent from '../../../../../../assets/js/clientAgent'

export default {
  name: 'SeznamRoamingDrzav',
  data () {
    return {
      seznamDrzav: null,
      loading: true
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.NaloziSeznamRoamingDrzav()
  },
  methods: {
    NaloziSeznamRoamingDrzav () {
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/telefonija/umts/seznamRoamingDrzav',
        [],
        null,
        'SetSeznamRoamingDrzav',
        'ErrSeznamRoamingDrzav')
    },
    SetSeznamRoamingDrzav (podatki) {
      this.loading = false
      this.seznamDrzav = null
      if (typeof podatki.data !== 'undefined' && podatki.data.length > 0) {
        this.seznamDrzav = podatki.data
      }
    },
    ErrSeznamRoamingDrzav () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Napaka pri pridobivanju seznama roaming držav'
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>

<style scoped>
.odmik-vsebine-nastavtive-telefonija{
  min-height: 52px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/SeznamRoamingDrzav.vue